var exports = {
  "J": "ProfileCardContent.module__contentSection___YXlkSm",
  "s": "ProfileCardContent.module__contentSectionWebhook___YXlkSm",
};

module.exports = exports;
